import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { validationSchema, initialValues } from "./addOrderBillingConfig.js";
import { XMLParser } from "fast-xml-parser";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Loader from "../../../../components/loader/index.js";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Swal from "sweetalert2";
import axiosClient from "../../../../config/axios.js";

import {
  findFiscalRegimesByCoincidence,
  findCFDIByCoincidence,
  findPaymentFormByCoincidence,
  getFoliosBySocialReason,
  getSeriesBySocialReason,
  findCustomerSocialReasonByCoincidence,
  findPaymentMethodByCoincidence,
  getMySocialReasons,
  createStamp,
  getStampFile,
} from "../../../../services/CatalogService";

import moment from "moment-timezone";

import CartaPorteFormFields from "../orderCartaPorte/cartaPorteFormFields.js";
import TableConceptsCartaPorte from "../orderCartaPorte/tableConceptsCartaPorte.js";
import NewCustomerCartaPorte from "../orderCartaPorte/newCustomerCartaPorte.js";

import { FormikProvider } from "formik";
import DatatableStampedInvoices from "../../ordersVial/formOrderVial/invoice/datatableStampedInvoices.js";

function AddOrderBilling() {
  const razonSocialAPI = "GruasVaro";
  const navigate = useNavigate();

  const [razonSocial, setRazonSocial] = useState([""]);
  const [orden, setOrden] = useState(null); // datos de la orden
  const { id } = useParams();

  const [folios, setFolios] = useState([]);
  const [series, setSeries] = useState([]);

  const [conceptoFactura, setconceptoFactura] = useState("");
  const [fecha, setFecha] = useState("");
  const [pagosContado, setPagosContado] = useState([]);
  const [pagosCredito, setPagosCredito] = useState([]);
  const [selectedProductKey, setSelectedProductKey] = useState(null);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
  const [showCartaPorteForm, setShowCartaPorteForm] = useState(true);

  const [loading, setLoading] = useState(true);
  const [lastInvoice, setLastInvoice] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const buildCfdiObject = (values) => {
    return {
      Version: "4.0",
      Moneda: "MXN",
      Fecha: values.fecha + "T00:00:00",
      Serie: values.serie,
      Folio: values.folio,
      TipoDeComprobante: "I", // ingreso
      Exportacion: "01", // no aplica exportación
      FormaPago: values.paymentMethodId.id,
      MetodoPago: values.paymentFormId.id,
      LugarExpedicion: values.customerId.socialReason.postalCode,
      Receptor: {
        Rfc: values.customerId.rfc,
        Nombre: values.customerId.name,
        DomicilioFiscalReceptor: values.customerId.postalCode,
        RegimenFiscalReceptor: values.fiscalRegimeId?.id ?? "",
        UsoCFDI: values.cfdiId.id,
      },
      lada: values.customerId.lada_phone,
      phone: values.customerId.phone,
      ObjetoImp: "02",
      Conceptos: values.conceptosFacturaTabla.map((c) => {
        const precioSinIva = parseFloat(c.precioUnitario) || 0;
        const cantidad = parseFloat(c.cantidad) || 0;

        // Conversión a valores con IVA
        const valorUnitarioConIva = precioSinIva * 1.16;
        const importeConIva = valorUnitarioConIva * cantidad;

        return {
          ClaveProdServ: c.productKey.productKey_idKey,
          Cantidad: cantidad.toString(),
          ClaveUnidad: c.unitKey.unitKey_idKey,
          Unidad: "Servicio",
          Descripcion: c.Descripcion,
          needRetention: c.needRetention,

          // Valores correctos con IVA (tu API los espera así)
          ValorUnitario: valorUnitarioConIva.toFixed(2),
          Importe: importeConIva.toFixed(2),

          Descuento: "0.00",
          ObjetoImp: "02",
        };
      }),
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchema,
    initialValues: initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(false);
      try {
        // lógica para guardar
        const confirmResult = await Swal.fire({
          title: "¿Estás seguro?",
          text: "¿Deseas realizar la factura de esta orden?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, facturar",
          cancelButtonText: "Cancelar",
        });

        if (!confirmResult.isConfirmed) {
          setSubmitting(false);
          return;
        }
        setSubmitting(true);

        console.log("Valores enviados:", values);
        const cfdiObject = buildCfdiObject(values);

        const data = await createStamp(cfdiObject, razonSocialAPI);
        console.log("datos api", data);

        // Función para limpiar a número
        const cleanNumber = (value) => {
          if (!value) return 0;
          const cleaned = value.toString().replace(/[^0-9.-]+/g, "");
          return cleaned === "" ? 0 : Number(cleaned);
        };

        // Parsear XML del cfdi
        const parser = new XMLParser({
          ignoreAttributes: false,
          attributeNamePrefix: "@_",
        });

        const cfdiXml = data.cfdi.cfdi;
        const cfdiParsed = parser.parse(cfdiXml);

        // El comprobante viene en cfdi:Comprobante
        const comprobante = cfdiParsed["cfdi:Comprobante"];

        // Extraer subtotal y total desde atributos
        const subtotal = cleanNumber(comprobante["@_SubTotal"]);
        const total = cleanNumber(comprobante["@_Total"]);
                
        // Extraer impuestos
        const impuestos = comprobante["cfdi:Impuestos"] || {};
        const traslados = impuestos["cfdi:Traslados"]?.["cfdi:Traslado"];
        const trasladoIVA = Array.isArray(traslados)
          ? traslados[0]
          : traslados || {};

        // IVA total (usa TotalImpuestosTrasladados si existe, si no, el importe del traslado)
        const iva = cleanNumber(
          impuestos["@_TotalImpuestosTrasladados"] ||
            trasladoIVA["@_Importe"] ||
            0
        );

        const retencion = cleanNumber(
          impuestos["@_TotalImpuestosRetenidos"] || 0
        );
        
        // Construir payload
        const stampedInvoicePayload = {
          uuid_stamp: data.cfdi.uuid,
          issued_at: moment.utc().format(),
          status: data.cfdi.status || "vigente",
          orderId: id,
          id_facturacion_stamp: data.id,
          customer_name: cfdiObject.Receptor.Nombre || "SIN NOMBRE",
          customer_rfc: cfdiObject.Receptor.Rfc || "XAXX010101000",
          total,
          subtotal,
          iva,
          retencion
        };

        console.log("Payload que se enviará:", stampedInvoicePayload);

        await axiosClient.post("/stamped-invoice/save", stampedInvoicePayload);

        setLastInvoice(stampedInvoicePayload);
        setRefreshKey((oldKey) => oldKey + 1);
        //}

        Swal.fire({
          title: "¡Éxito!",
          text: "Factura creada correctamente",
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        console.log("Objeto a enviar factura:", cfdiObject);
      } catch (err) {
        const errorData = err.response?.data;
        const errorMessage = Array.isArray(errorData?.message)
          ? errorData.message.join(", ")
          : errorData?.message ||
            errorData?.error ||
            "Ha ocurrido un error inesperado";

        Swal.fire({
          title: "Ups!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "Cerrar",
          showCancelButton: false,
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const localDate = moment.tz("America/Mexico_City").format("YYYY-MM-DD");
    setFecha(localDate);
    formik.setFieldValue("fecha", localDate);

    const fetchOrder = async () => {
      try {
        setLoading(true);

        // Obtener orden
        const { data: ordenData } = await axiosClient.get(`/orders/${id}`);
        setOrden(ordenData);
        console.log("Datos orden:", ordenData);

        // Obtener pagos activos (contado y crédito)
        const [contadoRes, creditoRes] = await Promise.all([
          axiosClient.get(
            `/payments/activePaymentsByOrder/${id}?only_active_payments=true&payment_type_code=CONTADO`
          ),
          axiosClient.get(
            `/payments/activePaymentsByOrder/${id}?only_active_payments=true&payment_type_code=CREDITO`
          ),
        ]);

        setPagosContado(contadoRes.data || []);
        setPagosCredito(creditoRes.data || []);

        // console.log("Pagos contado:", contadoRes.data);
        // console.log("Pagos crédito:", creditoRes.data);
      } catch (error) {
        Swal.fire("Error", "No se pudo cargar la orden o los pagos", "error");
      } finally {
        setLoading(false);
      }
    };

    // Cargar folios, series y razones sociales
    const loadCatalogs = async () => {
      const rs = await getMySocialReasons(razonSocialAPI);
      setRazonSocial(rs);

      const foliosData = await getFoliosBySocialReason(razonSocialAPI);
      setFolios(foliosData);

      const seriesData = await getSeriesBySocialReason(razonSocialAPI);
      setSeries(seriesData);
    };

    fetchOrder();
    loadCatalogs();
  }, []);

  useEffect(() => {
    const customer = formik.values.customerId;

    const setCfdiAndRegime = async () => {
      if (customer && customer.cfdi && customer.fiscalRegime) {
        try {
          // Buscar CFDI por ID
          const cfdiResults = await findCFDIByCoincidence(customer.cfdi.id);
          if (cfdiResults?.length) {
            formik.setFieldValue("cfdiId", cfdiResults[0], true);
          } else {
            formik.setFieldValue("cfdiId", null, true);
          }

          // Buscar Régimen Fiscal por ID
          const regimeResults = await findFiscalRegimesByCoincidence(
            customer.fiscalRegime.id
          );
          if (regimeResults?.length) {
            formik.setFieldValue("fiscalRegimeId", regimeResults[0], true);
          } else {
            formik.setFieldValue("fiscalRegimeId", null, true);
          }
        } catch (error) {
          console.error("Error buscando cfdi/regimen:", error);
          formik.setFieldValue("cfdiId", null, true);
          formik.setFieldValue("fiscalRegimeId", null, true);
        }
      } else {
        formik.setFieldValue("cfdiId", null, true);
        formik.setFieldValue("fiscalRegimeId", null, true);
      }
    };

    setCfdiAndRegime();
  }, [formik.values.customerId]);

  const handleNewCustomerClick = () => {
    setShowCartaPorteForm(false);
    setShowNewCustomerForm(true);
  };

  if (loading || !initialValues) return <Loader isLoading={true} />;

  if (showNewCustomerForm) {
    return (
      <NewCustomerCartaPorte
        onBack={(newCustomer) => {
          setShowNewCustomerForm(false);

          if (newCustomer) {
            formik.setFieldValue("customerId", newCustomer);
          }
        }}
      />
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/facturacion-ordenes">Facturación de órdenes</Link>
            </li>
            <li className="breadcrumb-item active">Nueva factura</li>
          </ol>
          <h1 className="page-header mb-0">
            Registro de nueva factura - Folio{" "}
            {orden.folio.toString().padStart(5, "0")}
          </h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Form noValidate onSubmit={formik.handleSubmit}>
            <Loader isLoading={formik.isSubmitting} />

            <Panel>
              <PanelHeader>Registro de nueva Factura</PanelHeader>
              <PanelBody>
                <CartaPorteFormFields
                  formik={formik}
                  razonSocialAPI={razonSocialAPI}
                  conceptoFactura={conceptoFactura}
                  setconceptoFactura={setconceptoFactura}
                  fecha={fecha}
                  setFecha={setFecha}
                  folios={folios}
                  series={series}
                  razonSocial={razonSocial}
                  setCustomerId={(value) =>
                    formik.setFieldValue("customerId", value)
                  }
                  findPaymentFormByCoincidence={findPaymentFormByCoincidence}
                  findPaymentMethodByCoincidence={
                    findPaymentMethodByCoincidence
                  }
                  findCustomerSocialReasonByCoincidence={
                    findCustomerSocialReasonByCoincidence
                  }
                  findCFDIByCoincidence={findCFDIByCoincidence}
                  findFiscalRegimesByCoincidence={
                    findFiscalRegimesByCoincidence
                  }
                  onNewCustomerClick={handleNewCustomerClick}
                />
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Conceptos</PanelHeader>
              <PanelBody>
                <FormikProvider value={formik}>
                  <div className="my-4">
                    <div className="mb-3">
                      <TableConceptsCartaPorte
                        formik={formik}
                        selectedProductKey={selectedProductKey}
                        setSelectedProductKey={setSelectedProductKey}
                        orden={orden}
                      />
                    </div>
                  </div>
                </FormikProvider>
              </PanelBody>
            </Panel>
            <Row className="mb-3">
              <Col md="12" className="d-flex justify-content-end gap-2">
                {/* {!lastInvoice ? ( */}
                {/* {lastInvoice && (
                  <Button type="button" onClick={handleDownloadCartaPorte}>
                    Descargar Factura previamente creada
                  </Button>
                )} */}
                {/* ) : ( */}
                <Button type="submit" disabled={formik.isSubmitting}>
                  Facturar
                </Button>
                {/* )} */}
                <Link to="/facturacion-ordenes" className="btn btn-info">
                  Cancelar
                </Link>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <br></br>
      <Panel>
        <PanelHeader>Registro de Facturas</PanelHeader>
        <PanelBody>
          <Row>
            <Col md="12">
              <h3>
                <i className="fa-solid fa-file-invoice"></i> Facturas de la
                orden{" "}
              </h3>
            </Col>
          </Row>
          <DatatableStampedInvoices
            razonSocialFacturacion={razonSocialAPI}
            refreshKey={refreshKey}
          />
        </PanelBody>
      </Panel>
    </div>
  );
}

export default AddOrderBilling;
